// Product page swatches: hovering a swatch previews its value in the option's
// selected label, which reverts to the selected swatch when the pointer leaves
(function () {
  var swatchSelector = ".product-form__color-swatch";

  function setLabel(group, swatch) {
    var label = group.querySelector("[data-option-selected]");
    if (label && swatch) label.textContent = swatch.getAttribute("aria-label");
  }

  document.addEventListener("mouseover", function (e) {
    var swatch = e.target.closest && e.target.closest(swatchSelector);
    if (!swatch) return;
    setLabel(swatch.closest("[data-option-buttons]"), swatch);
  });

  document.addEventListener("mouseout", function (e) {
    var swatch = e.target.closest && e.target.closest(swatchSelector);
    if (!swatch) return;
    var next = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest(swatchSelector);
    var group = swatch.closest("[data-option-buttons]");
    if (!group || (next && group.contains(next))) return;
    setLabel(group, group.querySelector(swatchSelector + ".selected"));
  });
})();
